export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20entertainment%20newsroom%20atmosphere%20with%20warm%20crimson%20and%20amber%20lighting%2C%20abstract%20stage%20spotlights%20against%20deep%20black%20background%2C%20cinematic%20glow%20effects%2C%20breaking%20news%20aesthetic%2C%20high%20contrast%20dramatic%20composition%2C%20no%20text%2C%20no%20people%2C%20pure%20atmospheric%20visual&width=1800&height=900&seq=hero-main-bg&orientation=landscape"
          alt="每日大赛官网 - 娱乐资讯聚合平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-surface-950/80 via-surface-950/60 to-surface-950/95"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-0">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-brand-500/20 border border-brand-500/30 mb-6">
              <span className="w-2 h-2 rounded-full bg-brand-400 animate-pulse-slow"></span>
              <span className="text-brand-400 text-xs font-semibold tracking-wide">每日更新 · 实时追踪</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight tracking-tight">
              每日大赛官网
              <span className="block text-brand-400 mt-2">一手黑料吃瓜赛事入口</span>
            </h1>

            <p className="text-surface-300 text-base md:text-lg leading-relaxed mt-6 max-w-xl mx-auto lg:mx-0">
              每日大赛官网聚合全网最新娱乐资讯与吃瓜内容，覆盖明星动态、综艺翻车、片场爆料、直播事故等全品类热门话题。每日早中晚三次内容刷新，最新地址一站直达，确保你不错过娱乐圈任何一个精彩瞬间。
            </p>

            <p className="text-surface-400 text-sm leading-relaxed mt-3 max-w-xl mx-auto lg:mx-0">
              当前热点聚焦：顶流恋情曝光持续发酵、知名综艺录制现场翻车、豪门千金婚后生活大起底 —— 编辑部正在全力追踪，更多独家内容即将上线。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 mt-8">
              <div className="flex items-center gap-2 text-surface-400 text-sm">
                <i className="ri-article-line text-brand-400"></i>
                <span>日均更新 <strong className="text-white">30+</strong> 条内容</span>
              </div>
              <div className="flex items-center gap-2 text-surface-400 text-sm">
                <i className="ri-group-line text-brand-400"></i>
                <span>覆盖 <strong className="text-white">12</strong> 大内容品类</span>
              </div>
              <div className="flex items-center gap-2 text-surface-400 text-sm">
                <i className="ri-shield-check-line text-brand-400"></i>
                <span>多重信源 <strong className="text-white">交叉验证</strong></span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <a
                href="#app"
                onClick={(e) => {
                  e.preventDefault();
                  const el = document.querySelector('#app');
                  if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 64, behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3.5 bg-brand-500 hover:bg-brand-600 text-white text-base font-bold rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap text-center"
              >
                立即下载APP
              </a>
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  const el = document.querySelector('#ranking');
                  if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 64, behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3.5 bg-surface-800/80 hover:bg-surface-700 text-white text-base font-medium rounded-lg border border-surface-600/50 transition-all duration-200 cursor-pointer whitespace-nowrap text-center"
              >
                查看热榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden border border-surface-700/40 aspect-[4/5]">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20showing%20entertainment%20news%20app%20interface%20with%20dark%20theme%2C%20trending%20gossip%20headlines%20on%20screen%2C%20warm%20crimson%20accent%20colors%2C%20sleek%20device%20on%20minimal%20dark%20background%2C%20premium%20product%20photography%2C%20soft%20studio%20lighting%2C%20high%20detail%2C%20professional%20composition&width=800&height=1000&seq=hero-visual-mockup&orientation=portrait"
                alt="每日大赛APP界面预览 - 最新娱乐资讯一手掌握"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-surface-950/40 to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}